import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import { motion } from 'framer-motion';
import { wstepy } from '../../functions/motions';
import WodaListaWspolnot from "./WodaListaWspolnot.js";
import GoBackBtn from "../GoBackBtn.js";
import { getTablicaCzynsze2 } from "../../functions/tablice.js";

import { 
    fetchWspolnoty, 
    fetchOdczyty,
    fetchOdczytyWm,
    fetchPlanowaneZuzycie,
    fetchMieszkancy,
    fetchLokale, 
    fetchUlice, 
    fetchGrupy, 
    fetchUdzialyKontaAkt,
    fetchUdzialyKonta,
    fetchUsers,
    fetchWspolnota,
    fetchStawki,
    fetchStawkiInd,
    fetchStawkiJednorazowe,
    fetchStawkiJednorazoweInd,
    fetchRozliczenieWodyWmSaved
} from '../../Redux/Actions.js'; 
import WodaMieszkancy from "./WodaMieszkancy.js";
import WodaOdczytyRazem from "./OdczytyRazem/WodaOdczytyRazem.js";
import DialogYesNo from "../DialogYesNo";
import WodaGrupowe from "./Grupowe/WodaGrupowe.js";
import { obliczRozliczenieWody, obliczStrate } from "../../functions/woda.js";
import WodaMieszkancySeryjne from "./Seryjne/WodaMieszkancySeryjne.js";

const Woda = () => {

    const [wybranaWspolnota, setWybranaWspolnota] = useState({id: 0});
    const [wybranyMieszkaniec, setWybranyMieszkaniec] = useState(undefined);
    const [ulicaId, setUlicaId] = useState(0);    
    const [editDataOd, setEditDataOd] = useState(undefined);
    const [editDataDo, setEditDataDo] = useState(undefined);
    const [grupy_g, setGrupy_g] = useState(undefined);
    const [grupaUdzial, setGrupaUdzial] = useState(undefined);
    const [user, setUser] = useState(undefined);
    const [wybraneGrupyUdzial, setWybraneGrupyUdzial] = useState(undefined);
    const [rodzajLokalu, setRodzajLokalu] = useState("mieszkanie"); 
    const [bezdomni, setBezdomni] = useState([]);
    const [bezdomny, setBezdomny] = useState([]);
    const [addGrupe, setAddGrupe] = useState(false);
    const [wybranyOdczyt, setWybranyOdczyt] = useState(undefined);
    const [mieszkaniecArr, setMieszkaniecArr] = useState([]);
    const [czyWybranaWspolnota, setCzyWybranaWspolnota] = useState(false);
    const [loaderOn, setLoaderOn] = useState(false);

    const [wybranyZakres, setWybranyZakres] = useState(undefined);

    const [activeWindow, setActiveWindow] = useState("mieszkancy");

    const handleWindow = strona => {
        setWybranaWspolnota({id: 0});
        setActiveWindow(strona);
    }
    
    const [tablicaCzynsze, setTablicaCzynsze] = useState(undefined);
    const [tablicaCzynsze_u, setTablicaCzynsze_u] = useState(undefined);
    const [tablicaCzynsze_g, setTablicaCzynsze_g] = useState(undefined);
    // const [tablicaPrzelewy, setTablicaPrzelewy] = useState(undefined);
    // const [tablicaPrzelewy_g, setTablicaPrzelewy_g] = useState(undefined);

    const [open, setOpen] = useState(false);
    const [trashId, setTrashId] = useState(0);

    const [grupy_u, setGrupy_u] = useState([]);
    const [udzialyKonta_u, setUdzialyKonta_u] = useState([]);
    const [udzialyKontaAkt_u, setUdzialyKontaAkt_u] = useState([]);
    const [planowaneZuzycie_u, setPlanowaneZuzycie_u] = useState([]);
    const [stawkiInd_g, setStawkiInd_g] = useState([]);
    const [stawkiJednorazoweInd_u, setStawkiJednorazoweInd_u] = useState([]);
    const [odczyty_u, setOdczyty_u] = useState([]);

    const [rozliczenieWody, setRozliczenieWody] = useState([]);

    const location = useLocation();
    const state = location.state; 

    const dispatch = useDispatch();

    const wspolnotaArr = useSelector( state => state?.wspolnota?.data);
    const wspolnoty = useSelector( state  => state?.wspolnoty?.data);
    const odczyty = useSelector( state => state?.odczyty?.data);
    const odczytyWm = useSelector( state => state?.odczytyWm?.data);
    const planowaneZuzycie = useSelector( state => state?.planowaneZuzycie?.data);
    const mieszkancy = useSelector( state => state?.mieszkancy?.data);
    const lokale = useSelector( state => state?.lokale?.data);
    const ulice = useSelector( state => state?.ulice?.data);
    const grupy = useSelector( state => state?.grupy?.data);
    const udzialyKonta = useSelector( state => state?.udzialyKonta?.data);
    const udzialyKontaAkt = useSelector( state => state?.udzialyKontaAkt?.data);
    const users = useSelector( state => state?.users?.data);
    const stawki = useSelector( state => state?.stawki?.data);
    const stawkiInd = useSelector( state => state?.stawkiInd?.data);
    const stawkiJednorazowe = useSelector( state => state?.stawkiJednorazowe?.data);
    const stawkiJednorazoweInd = useSelector( state => state?.stawkiJednorazoweInd?.data);
    const rozliczenieWodyWmSaved = useSelector( state => state?.rozliczenieWodyWmSaved?.data);

    const [wybraneRozliczenie, setWybraneRozliczenie] = useState(undefined);

    useEffect( () => dispatch(fetchWspolnoty()), [dispatch]);

    useEffect( () => setMieszkaniecArr(mieszkancy?.filter( m => m?.id_user == wybranyMieszkaniec?.id_user)), [mieszkancy, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setGrupy_u( grupy?.filter( g => g?.id_user == wybranyMieszkaniec?.id_user) ),[grupy, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setUdzialyKonta_u( udzialyKonta?.filter( u => u?.id_user == wybranyMieszkaniec?.id_user)), [udzialyKonta, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setUdzialyKontaAkt_u( udzialyKontaAkt?.filter( u => u?.id_user == wybranyMieszkaniec?.id_user)), [udzialyKontaAkt, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setStawkiJednorazoweInd_u( stawkiJednorazoweInd?.filter( s => s?.id_user == wybranyMieszkaniec?.id_user)), [stawkiJednorazoweInd, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setPlanowaneZuzycie_u( planowaneZuzycie?.filter( p => p?.id_user == wybranyMieszkaniec?.id_user )), [planowaneZuzycie, wybranyMieszkaniec, wybranaWspolnota]);
    useEffect( () => setStawkiInd_g(stawkiInd?.filter( s => s?.id_user == grupaUdzial?.id_user && s?.grupa_numer == grupaUdzial?.grupa_numer)),[stawkiInd, grupaUdzial, wybranaWspolnota]);
    useEffect( () => setOdczyty_u( odczyty?.filter( o => o?.id_user == wybranyMieszkaniec?.id_user && o?.grupa_numer == wybranyMieszkaniec?.grupa_numer ) ), [odczyty, wybranyMieszkaniec]);
    
    useEffect( () => {
        setUlicaId(0);
        setRodzajLokalu("mieszkanie");
        setWybraneRozliczenie(undefined);
    },[wybranaWspolnota])

    useEffect( () => {
        let temp = [];
        mieszkancy?.forEach( m => {
            if (udzialyKontaAkt?.filter( u => u?.id_user == m?.id_user)?.length === 0)
                temp.push(m);
        })
        setBezdomni(temp)
    },[mieszkancy, udzialyKontaAkt]);

    useEffect( () => {
        const id = wybranaWspolnota && wybranaWspolnota?.id > 0 ? wybranaWspolnota?.id : 0;
        setWybranyMieszkaniec(undefined);
        dispatch(fetchMieszkancy(id));
        dispatch(fetchLokale(id));
        dispatch(fetchUlice(id)); 
        dispatch(fetchPlanowaneZuzycie(id));
        dispatch(fetchGrupy(id)); 
        dispatch(fetchUdzialyKonta(id));
        dispatch(fetchUdzialyKontaAkt(id));
        dispatch(fetchUsers(id));
        dispatch(fetchOdczyty(id));
        dispatch(fetchOdczytyWm(id));
        dispatch(fetchWspolnota(id));
        dispatch(fetchStawki(id));
        dispatch(fetchStawkiInd(id));
        dispatch(fetchStawkiJednorazowe(id));
        dispatch(fetchStawkiJednorazoweInd(id));
        dispatch(fetchRozliczenieWodyWmSaved(id));
    }, [wybranaWspolnota]);

    useEffect( () => { 
        if (czyWybranaWspolnota)
            setTablicaCzynsze(getTablicaCzynsze2(wspolnotaArr, mieszkancy, grupy, [], udzialyKonta, udzialyKontaAkt, lokale, stawki, planowaneZuzycie, stawkiJednorazowe, stawkiInd, stawkiJednorazoweInd))
    },[wspolnotaArr, mieszkancy, grupy, udzialyKonta, udzialyKontaAkt, lokale, stawki, planowaneZuzycie, stawkiInd, stawkiJednorazoweInd, wybranaWspolnota])

    useEffect( () => {
        if (czyWybranaWspolnota)    
            setTablicaCzynsze_u(getTablicaCzynsze2(wspolnotaArr, mieszkaniecArr, grupy_u, [], udzialyKonta_u, udzialyKontaAkt_u, lokale, stawki, planowaneZuzycie_u, stawkiJednorazowe, stawkiInd_g, stawkiJednorazoweInd_u))
    },[wspolnotaArr, mieszkaniecArr, grupy_u, udzialyKonta_u, udzialyKontaAkt_u, lokale, stawki, planowaneZuzycie_u, stawkiInd_g, stawkiJednorazoweInd_u])

    useEffect( () => {
        if (tablicaCzynsze_u?.length > 0) {
            const u = tablicaCzynsze_u[0]?.grupy?.find( t => t?.id_user == grupaUdzial?.id_user)?.grupy_udzial_msc;            
            const g = u?.find( u => u?.grupa_numer == grupaUdzial?.grupa_numer)
            setTablicaCzynsze_g( g?.temp_msc )
        }
    },[tablicaCzynsze_u, grupaUdzial]);
    
    useEffect(() => setGrupy_g( grupy?.filter( g=> g?.id_user == grupaUdzial?.id_user && g?.grupa_numer == grupaUdzial?.grupa_numer ) ), [grupy, grupaUdzial]);
    
    useEffect( () => setCzyWybranaWspolnota( wybranaWspolnota && wybranaWspolnota?.id > 0 ? true : false ), [wybranaWspolnota]);

    useEffect( () => {
       if (czyWybranaWspolnota && tablicaCzynsze && tablicaCzynsze?.length > 0) {
            setRozliczenieWody(obliczRozliczenieWody(odczyty, odczytyWm, lokale, udzialyKontaAkt, grupy, tablicaCzynsze[0]?.grupy));
       } 
    },[odczytyWm, odczyty, lokale, udzialyKontaAkt, grupy, tablicaCzynsze, czyWybranaWspolnota, wybranyZakres]);

    const remove = id => {
        try {
            axios.post('/api/odczyty-wm/usun', {
                id,
            }).then( response => {
                dispatch(fetchOdczytyWm(wybranaWspolnota?.id));
            })
        } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
        }
    }

    const page = () => {
        switch(activeWindow) {
            case "mieszkancySeryjne":
                return <WodaMieszkancySeryjne
                    rozliczenieWody={rozliczenieWody}
                    ulice={ulice}
                    lokale={lokale}
                    mieszkancy={mieszkancy}
                    udzialyKontaAkt={udzialyKontaAkt}
                    grupy={grupy}
                    wybranaWspolnota={wybranaWspolnota}
                />
            case "mieszkancy":
                return <WodaMieszkancy
                    mieszkaniec={wybranyMieszkaniec}
                    mieszkancy={mieszkancy}
                    setMieszkaniec={setWybranyMieszkaniec}
                    ulice={ulice}
                    ulicaId={ulicaId}
                    lokale={lokale}
                    setUlicaId={setUlicaId}
                    udzialyKontaAkt={udzialyKontaAkt}
                    setEditDataOd={setEditDataOd}   
                    setEditDataDo={setEditDataDo}
                    grupaUdzial={grupaUdzial}
                    setGrupaUdzial={setGrupaUdzial}
                    users_w={users}
                    setUser={setUser}
                    grupy={grupy}
                    wybraneGrupyUdzial={wybraneGrupyUdzial}
                    setWybraneGrupyUdzial={setWybraneGrupyUdzial}
                    rodzajLokalu={rodzajLokalu}
                    setRodzajLokalu={setRodzajLokalu}
                    setAddGrupe={setAddGrupe}
                    setWybranyOdczyt={setWybranyOdczyt}
                    state={state}
                    bezdomni={bezdomni}
                    wybranyMieszkaniec={wybranyMieszkaniec}
                    odczyty={odczyty}
                    planowaneZuzycie={planowaneZuzycie}
                    tablicaCzynsze_g={tablicaCzynsze_g}
                    wybranyOdczyt={wybranyOdczyt}
                    grupy_g={grupy_g}
                    rozliczenieWody={rozliczenieWody}
                    setLoaderOn={setLoaderOn}
                />
            case "grupowe":
                return <WodaGrupowe
                    mieszkancy={mieszkancy}
                    ulice={ulice}
                    lokale={lokale}
                    users={users}
                    grupy={grupy}
                    udzialyKontaAkt={udzialyKontaAkt}
                    odczyty={odczyty}
                    planowaneZuzycie={planowaneZuzycie}
                    wybranaWspolnota={wybranaWspolnota}
                    czyWybranaWspolnota={czyWybranaWspolnota}
                />
            case "odczytyWm":
                return <WodaOdczytyRazem
                    odczyty={odczyty}
                    odczytyWm={odczytyWm}
                    wybranaWspolnota={wybranaWspolnota}
                    ulice={ulice}
                    lokale={lokale}
                    udzialyKontaAkt={udzialyKontaAkt}
                    grupy={grupy}
                    mieszkancy={mieszkancy}
                    setOpen={setOpen}
                    setTrashId={setTrashId}
                    czyWybranaWspolnota={czyWybranaWspolnota}
                    rozliczenieWody={rozliczenieWody}
                    wybranyZakres={wybranyZakres}
                    setWybranyZakres={setWybranyZakres}
                    wybraneRozliczenie={wybraneRozliczenie}
                    setWybraneRozliczenie={setWybraneRozliczenie}
                    rozliczenieWodyWmSaved={rozliczenieWodyWmSaved}
                />
            default:
                return <Fragment></Fragment>
        }
    }
    
    return (
        <motion.div 
            className="content"
            variants={wstepy}
            initial="initial"
            animate="animate"
        >
            <div className="woda2">
                <h1 className="nazwa">
                    Woda
                </h1>
                <div className="buttons">
                    <GoBackBtn/>
                    <button className={activeWindow === "mieszkancy" ? "active" : ""} onClick={()=>{handleWindow("mieszkancy")}}>Rozliczenia mieszkańców</button>
                    <button className={activeWindow === "grupowe" ? "active" : ""}  onClick={()=>{handleWindow("grupowe")}}>Mieszkańcy - grupowe</button>
                    <button className={activeWindow === "odczytyWm" ? "active" : ""} onClick={()=>{handleWindow("odczytyWm")}}>Odczyty WM</button>
                    <button className={activeWindow === "mieszkancySeryjne" ? "active" : ""} onClick={()=>{handleWindow("mieszkancySeryjne")}}>Wydruki seryjne</button>
                </div>
                <WodaListaWspolnot
                    wspolnoty={wspolnoty}
                    odczyty={odczyty}
                    wybranaWspolnota={wybranaWspolnota}
                    setWybranaWspolnota={setWybranaWspolnota}
                />
                <div className="woda-content">
                    { page() }
                </div>    
            </div>        
            <DialogYesNo 
                open={open}
                setOpen={setOpen}
                message={`Czy na pewno chcesz usunąć ten wpis?`}
                f={remove}
                id={trashId}
            />    
        </motion.div>
    )
}

export default Woda;